// extracted by mini-css-extract-plugin
export var closeButton = "_36-0";